import { IMAGE } from '../elements/assets'

export const HERO_VIDEO_TIMESTAMPS = `
...on heroVideoTimestamps_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }
  description
  label

  poster: ${ IMAGE }
  video { url }
  videoUrl {
    url
  }

  timestamps {
    title
    hours
    minutes
    seconds
  }

  primaryButton {
    url
    title
  }

  secondaryButton {
    url
    title
  }

  formSettings {
    heading
    text
    formId
    redirectLocation {
      url
    }
    onlyBusinessEmail
    withBorder
    errorValidateBusinessEmail
  }
}
`